export const applicationReviewByAliasKey = "applicationByAlias";
